import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import PathwaysRouter from "./PathwaysRouter";
import InviteRouter from "./InviteRouter";

const getSubdomain = () => {
  const host = window.location.hostname;
  if (host.startsWith("pathways.")) return "pathways";
  if (host.startsWith("signup.") || host.startsWith("invite.")) return "invite";
  if (host === "localhost" || host === "127.0.0.1") return "invite";
  return null;
};

const App = () => {
  const subdomain = getSubdomain();

  return (
    <Router>
      {subdomain === "pathways" && <PathwaysRouter />}
      {subdomain === "invite" && <InviteRouter />}
      {!subdomain && <div>Unknown subdomain</div>}
    </Router>
  );
};

export default App;
